import { apiSlice } from "../../app/api/apiSlice";

export const deleteVoxSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		deleteVox: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/${credentials.loanGuid}/application/${credentials.borrowerPairId}/delete/${credentials.type}/`,
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useDeleteVoxMutation } = deleteVoxSlice;
